import { Group } from '@mantine/core';
import { UserBadge } from './UserBadge';

interface UserBadgeGroupProps {
  badges: string[];
  justify?: 'center' | 'left' | 'right';
}

export function UserBadgeGroup({ badges, justify = 'center' }: UserBadgeGroupProps) {
  if (!badges || badges.length === 0) return null;
  
  return (
    <Group gap={4} justify={justify} style={{ flexWrap: 'wrap', maxWidth: '100%' }}>
      {badges.map((badge) => (
        <UserBadge key={badge} badge={badge} />
      ))}
    </Group>
  );
}
